// extracted by mini-css-extract-plugin
module.exports = {"word":"TextWord_word__mvLd7","UthmanicHafs":"TextWord_UthmanicHafs__9DRAC","meQuran":"TextWord_meQuran__rnZF_","IndoPak":"TextWord_IndoPak__Vois6"};